var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"footer":_vm.footer},scopedSlots:_vm._u([{key:"ChargeModal",fn:function(ref){
var visible = ref.visible;
var param = ref.param;
var close = ref.close;
return [_c('ChargeModal',{attrs:{"close":close,"refresh":_vm.$refs.table.getList}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }